import { AbstractModel, DateUtil, isNullOrUndefined } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { OperationsAlertType } from './operations-alert-type';

@inheritSerialization(AbstractModel)
export class OperationsAlert extends AbstractModel {
  @autoserialize
  objectId: number;

  @autoserializeAs(OperationsAlertType)
  operationsAlertType: OperationsAlertType;

  @autoserialize
  assigned: boolean;

  @autoserializeAs(Date)
  assignedDate: Date;

  @autoserialize
  assignedToUserId: number;

  @autoserialize
  assignedByUserId: number;

  @autoserialize
  resolved: boolean;

  @autoserializeAs(Date)
  resolvedDate: Date;

  @autoserialize
  resolvedByUserId: number;

  @autoserialize
  resolutionComments: string;

  static OnSerialized(instance: OperationsAlert, json: any): void {
    super.OnSerialized(instance, json);

    if (!isNullOrUndefined(instance.assignedDate)) {
      json.assignedDate = DateUtil.serializeDate(instance.assignedDate);
    }

    if (!isNullOrUndefined(instance.resolvedDate)) {
      json.resolvedDate = DateUtil.serializeDate(instance.resolvedDate);
    }
  }

  static OnDeserialized(instance: OperationsAlert, json: any): void {
    super.OnDeserialized(instance, json);

    if (!isNullOrUndefined(json['assignedDate'])) {
      instance.assignedDate = DateUtil.deserializeDate(json['assignedDate']);
    }

    if (!isNullOrUndefined(json['resolvedDate'])) {
      instance.resolvedDate = DateUtil.deserializeDate(json['resolvedDate']);
    }
  }
}
